<template>
	<div class="full-height">
		<Header @menuChange="changeMenu"></Header>
		<div class="flex-center">
			<div class="main-container" ref="main">
				<div class="nav-bar">
					<span>
						当前位置：
						<a href="/">首页</a>
						<span> > </span>
						<a href="#">园馆介绍</a>
						<span> > </span>
						<a href="/building">纪念建筑</a>
					</span>
				</div>

				<div class="flex" style="min-height: 765px;justify-content: center;width: 100%;">
					<div class="text-overflow-hidden detail-container flex" style="width: 100%;">
						<div class="menu-container">
							<a v-for="item in menus.children" :href="getMenuLink(item)">
								<div :class="{'menu-item-icontainer-active' : (nowMenuId == item.id), 'menu-item-container':true, 'flex-center' : true}">
									{{item.nameZh}}
								</div>
							</a>
						</div>

						<div class="full-width">
							<!-- <div v-for="list in buildings" class="full-width">
								<a v-for="item in list" :href="'/detail/building?id=' + item.id">
									<div style="width: 30%;height: 160px;display: inline-block;margin: 10px;float: left;">
										<el-image :src="item.img" class="full-parent"></el-image>
										<div style="margin-top: 10px;">
											<span >{{item.name}}</span>
										</div>
									</div>
								</a>
							</div> -->
							
							<div v-for="list in buildings" class="full-width flex">
								<a v-for="item in list" :href="'/detail/building?id=' + item.id" style="width: 30%;display: inline-block;margin: 10px;">
									<div class="full-parent">
										<el-image :src="item.img" class="full-parent" style="height: 160px;"></el-image>
										<div style="margin-top: 10px;">
											<span >{{item.name}}</span>
										</div>
									</div>
								</a>
							</div>
							<div style="margin-top: 20px;">
								<el-pagination background :page-size="page.size"  layout="prev, pager, next" 
								@current-change="changePage" 
								:total="data.totalElements">
								</el-pagination>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '../../../components/Header';
	import Footer from '../../../components/Footer';
	import api from '../../../http/detail'
	export default {
		components: {
			Header,
			Footer
		},
		data() {
			return {
				page:{
					page : 0,
					size : 10,
					sort : "id,desc"
				},
				nowMenuId: 3,
				menus: {},
				data: {
					"type": 1,
					"thisMenu": {
						"createTime": "2021-03-15 12:09:13",
						"updateTime": "2021-03-28 10:55:34",
						"id": 3,
						"nameZh": "园馆历史",
						"nameEn": "history",
						"parentId": 2,
						"isOut": 0,
						"url": null,
						"sort": 999,
						"type": 2,
						"content": "<p>园馆历史<br/></p>",
						"isShow": 0
					},
					"parentMenu": {
						"createTime": "2021-03-15 11:57:28",
						"updateTime": "2021-03-27 17:12:29",
						"id": 2,
						"nameZh": "园馆介绍",
						"nameEn": "",
						"parentId": -1,
						"isOut": 0,
						"url": "",
						"sort": 999,
						"type": 0,
						"content": null,
						"isShow": 0
					},
					"articles": null,
					"content": "<p>园馆历史<br/></p>",
					"articlesList": null
				},
				buildings: [
					
				]
			}
		},
		methods: {
			getData(){
				const _this = this;
				api.getBuildings(this.page).then(res => {
					var outter = new Array()
					for(var i=0;i<res.content.length;i+=3){
						outter.push(res.content.slice(i,i+3))
					}
					_this.buildings = outter
					_this.data = res;
				})
			},
			changeMenu(allMenus){
				this.menus = allMenus.find(item => {
					if (item.id == 2) {
						return true;
					}
				});
				var menu = this.menus.children.find(item => {
					if(item.nameZh === "纪念建筑"){
						return true;
					}
				});
				this.nowMenuId = menu.id;
			},
			getMenuLink(item){
				if(item.isOut == 1){
					return item.url;
				}
				return '/detail?id=' + item.id + '&pid=' + item.parentId;
			},
			changePage(current){
				this.page.page = current - 1;
				this.getData();
			}
		},
		created() {
			this.getData();
		},
		mounted() {
			this.$refs.main.scrollIntoView()
		}
	}
</script>

<style>
	.main-container {
		width: 1200px;
	}

	.nav-bar {
		text-align: left;
		width: 100%;
		height: 16px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		margin: 23px 0;
	}

	.detail-container {
		margin: 23px 0 30px 30px;
		padding-right: 50pxs;
		width: 100%;
	}

	.menu-container {
		margin-right: 30px;
		background: #F7F7F7;
		height: fit-content;
	}

	.menu-item-container {
		width: 166px;
		height: 55px;
		color: #666666;
	}

	.menu-item-icontainer-active {
		background: #A10000;
		color: #FFFFFF !important;
	}
</style>



// WEBPACK FOOTER //
// src/views/detail/building/index.vue